//import UnorderedTopic from '../server/UnorderedTopic';
//import OrderedTopic from './server/OrderedTopic';
import {random} from 'lodash';
import { store } from './stores/mainStore';
import { colorNames } from './colors';
import { Match } from './stores/models/Match';
import { integration } from './integration';

// const hands = {
// 	1:		'high-card'       ,
// 	2:		'pair'            ,
// 	3:		'two-pair'        ,
// 	4:		'three-of-a-kind' ,
// 	5:		'straight'        ,
// 	6:		'flush'           ,
// 	7:		'full-house'      ,
// 	8:		'four-of-a-kind'  ,
// 	9:		'five-of-a-kind'  ,
// 	10:	'six-of-a-kind'   ,
// 	11:	'straight-flush'  ,
// 	12:	'royal-flush'
// };

export class MiddleLayer {
	constructor(connection, tutorial) {
		this.connection = connection;
		this.tutorialConnection = tutorial;
	}

	RemoveOpponent(opponentId){
		return this.connection.CallRoute('remove-friend-history', {
			"FriendId": opponentId
		});
	}

	SetPlatformData(platform,platformId,platformEmail){
		return this.connection.CallRoute('set-platform-data', {
			"Platform": platform,
			"PlatformUid": platformId,
			"Email": platformEmail
		});
	}

	LookupUser(id){
		return this.connection.CallRoute('lookup-user', {
			"UserId": id
		});
	}

	ClaimTimedHearts(){
		return this.connection.CallRoute('claim-clock-rolls', {});
	}

	WatchAd(adId, duration){
		return this.connection.CallRoute('watch-ad', {
			"AdId": adId || "anything",
			"Duration": duration || 15
		})
	}

	ResetTutorial(tutorial){
		this.tutorialConnection = tutorial;
		// this.tutorialConnection.callIndex = 1;
	}


	ClaimMatchReward = (matchId) => {
		return this.connection.CallRoute("claim-match-reward",{
			MatchId: matchId
		});
	}

	GetNotifications(){
		return Promise.resolve({
			Payload: {
				UserNotifications: []
			}
		});
		//return this.connection.CallRoute('get-notifications',{}, -1);
	}


	ConfirmNotification(key, delay){
		return new Promise((resolve, reject) => {
			setTimeout(() => {
				if(window.WrapperApp){
					// window.WrapperApp.postMessage('clearing notification')
				}
				this.connection.CallRoute('confirm-notification',{
					ConfirmationKey: key
				})
				.then(resolve)
				.catch(reject)
			}, delay);
		})
	}

	InviteFriend(platform, id){
		return this.connection.CallRoute('invite-friend',{
			"FriendPlatform": platform,
			"FriendId": id
		});
	}

	RegisterFCM(id){
		return this.connection.CallRoute('register-for-notifications',{
			FcmId: id
		});
	}

	UnregisterFCM(){
		return this.connection.CallRoute('unregister-for-notifications',{});
	}

	GetTos(){
		return this.connection.CallRoute('get-tos', {});
	}

	GetUnfinishedMatches(){
		return this.connection.CallRoute('get-unfinished-matches', {})
	}

	GetLobby(){
		return this.connection.CallRoute('lobby',{}, -1);
	}

	GetBotList(){
		return this.connection.CallRoute('get-bots',{});
	}

	AddErrorMessage(message, imperative = false, duration = null) {
		store.addMessage('error', message, imperative, duration);
	}

	PurchaseProduct = (receipt) => {
		let isAndroid = store.devicePlatform === 'android';
		if(isAndroid === true) {
			return this.connection.CallRoute("apply-purchase-go", receipt);

		} else if(store.isIOS)
			return this.connection.CallRoute("apply-purchase-ap", receipt);
	}

	SetUserLanguage = () => {
		var payload = {
			"UserLanguage": store.settings.language
		};
		console.log("setuserlanguage payload: ", payload);
		var ret = this.connection.CallRoute("set-user-language", payload);
		return ret;
	}
	restartGame = () => {
		window.WrapperApp.postMessage("restart-game");
	}

	Login = (abv, tosId, siuId, accountId, lang) => {
		var payload = {
			"AnonymousUsername": siuId || "",
			"AccountId": accountId || "",
			"UserLanguage": lang || store.settings.language,
			"AcceptedTosId": parseInt(tosId, 10) || 0
		};
		return this.connection.CallRoute("login-"+abv+"-user", payload)
	}

	LoginGuest = (name, tosId) => {
		var payload = {
			"AnonymousUsername": name || "",
			"UserLanguage": "en",
			"AcceptedTosId": parseInt(tosId || localStorage.getItem('acceptedTosId'), 10) || 0
		};
		return this.connection.CallRoute("login-anon-user", payload)
	}

	SetCommToken(token){
		this.connection.SetToken(token);
	}

	LinkExternal(force, platform, id){
		if(['ap','fb','go'].indexOf(platform) > -1){
			return this.connection.CallRoute('connect-account',{
				AccountPlatform: platform,
				AccountId: id,
				Force: force
			}).then((response) => {
				//if already linked, unlink the
				if(response.ErrorCode === 300023){
					localStorage.removeItem('username');
				}
				return response;
			});
		} else {
			console.warn('unknown platform '+platform)
		}
		return Promise.reject('Platform Invalid', platform);
	}

	SetProfile = (platform, name, image) => {
		return Promise.resolve();
	}

	GetAchievements(){
		return this.connection.CallRoute("get-achievements",{})
		.then((data) => {
			//console.log(data);
			return data;
		});
	}

	GetXpLevel(){
		return this.GetAchievements()
		.then((data) => {
			return data.Payload.Achievements.find(a => a.IsLevel);
		});
	}

	CreateRandomMatch = () => {
		return this.connection.CallRoute("create-match",{
			// "BetAmount": 10000,
			// "Version": 1
		});
	}

	CreateMatch = (oppId, rematchId) => {
		return this.connection.CallRoute("create-match", {
			OpponentUserId: oppId,
			RematchOf: rematchId
		});
	}

	AcceptChallenge = (matchId) => {
		return this.connection.CallRoute("accept-challenge",{
			MatchId: matchId
		});
	}

	Nudge = (matchId) => {
		return this.connection.CallRoute("send-nudge",{
			MatchId: matchId
		});
	}

	GetFriendDetails = (friendIds) => {
		return this.connection.CallRoute("get-friend-profiles",{
			AccountPlatform: "fb",
			AccountIds: friendIds
		});
	}

	Resume(){
		return this.connection.CallRoute('get-unfinished-matches')
		.then(response => {
			//console.log(response);
			if(response.Payload.MatchSummaries && response.Payload.MatchSummaries.length > 0){
				return this.GetMatch(response.Payload.MatchSummaries[0].GameMatchId)
				.then((response) => {
					// var m = response.Payload.Match;
					// var r = m.UserMatchRounds[m.UserMatchRounds.length - 1].Rolls[m.UserMatchRounds[m.UserMatchRounds.length - 1].Rolls.length - 1];
					// console.log('raw resume', response);
					// console.log('server Resume', {
					// 	'Current Round': m.UserCurrentRound,
					// 	'Round Hands': m.Rounds.map(r => `${hands[r.TargetHand]} - #${r.TargetHand}`),
					// 	'Free Rolls Used': m.FreeRollsUsed,
					// 	'Roll Number': r ? r.RollNum : 'No rolls',
					// 	'Latest Dice': r ? r.DiceRollStrings : 'No rolls',
					// 	'Held Dice': r ? r.Selection : 'No rolls',
					// 	'Dice Indexes': r ? r.DiceRoll : 'No rolls',
					// 	'Best Match': r ? r.BestHand : 'No rolls',
					// });
					store.setActiveMatch(new Match(response.Payload.Match, true), true);
					// console.log('computed resume', toJS(store.activeMatch));
					store.resuming = false;
					// store.user.lastBetAmount = -Match.Wager.Amount.Quantity;
					store.user.lastBetAmount = -response.Payload.Match.Wager.Amount.Quantity;
				})
			} else {
				store.resuming = false;
			}
		});
	}

	PlaceBet = (amount) => {
		if(!store.tutorialMode){
			//if low balance, warn integration partner and send a rejection.
			if(amount > store.user.balance){
				integration.onLowBalance();
				return Promise.reject('low balance');
			}
			store.user.balance -= amount;
		}

		store.betProcessing = true;
		// console.log('bet processing');

		var payload = {
			"BetAmount": amount,
			"Version": 1
		}

		var c = store.tutorialMode ? this.tutorialConnection : this.connection;

		return c.CallRoute('create-random-match', payload)
		.then((response) => {
			//store.user.balance = response.balance;
			store.user.lastBetAmount = amount;
			return this.GetMatch(response.Payload.MatchId)
			.then((response) => {
				store.betProcessing = false;
				integration.onMatchStart();
				store.setActiveMatch(new Match(response.Payload.Match, true));
			});
		}).catch((err) => {
			store.betProcessing = false;
			console.error('Match not created, refunding balance', err);
			store.user.balance += amount;
		});
	}

	StartMatchFromId(id){
		this.GetMatch(id)
		.then((data) => {
			store.betProcessing = false;
			// integration.onMatchStart();
			store.setActiveMatch(new Match(data.Payload.Match, true));
		});
	}

	GetMatch = (id) => {
		var payload = {
			"MatchId": id
		};

		var c = store.tutorialMode ? this.tutorialConnection : this.connection;

		return c.CallRoute('get-match', payload)
		.then((data) => {
			if(data.ErrorCode){
				return data;
			}
			data.Payload.Match.MatchId = id;
			if(data.Payload.Match.Opponents && data.Payload.Match.Opponents.length){
				data.Payload.Match.OpponentMatchRounds = data.Payload.Match.Opponents[0].MatchRounds;
			}
			if(data.Payload.Match.Opponents.length && data.Payload.OpponentSummary){
				data.Payload.Match.Opponents[0].summary = data.Payload.OpponentSummary;
			}
			return data;
		})
	}

	AbandonMatch = (id) => {
		if(!id){
			id = store.activeMatch.matchId;
		}
		var payload = {
			"MatchId": id
		};

		var c = store.tutorialMode ? this.tutorialConnection : this.connection;

		return c.CallRoute('resign-match', payload);
	}

	generateBotId(){
		var botIndex = random(1, colorNames.length) - 1;
		return colorNames[botIndex];
	}

	FinishTutorial(pay){

		if(pay === true) {
			window.WrapperApp.postMessage("tutorial-complete?success=true");
		}

		return this.connection.CallRoute('finish-tutorial', {
			PayUser: pay
		})
		.then(() => {
			// integration.postAnalyticsEvent(`complete`, 'postgame');
		});
	}

	SeenOutOfRolls(){
		return this.connection.CallRoute('out-of-rolls', {});
	}

	ContinueRoll = (id, held) => {
		var payload = {
			MatchId: id,
			Selection: held,
			"GiveUp": false
		}

		var c = store.tutorialMode ? this.tutorialConnection : this.connection;
		return c.CallRoute('roll-dice', payload);
	}

	CompleteHand(id, selection){
		var payload = {
			MatchId: id,
			// Selection: selection,
			// "GiveUp": true
		}
		var c = store.tutorialMode ? this.tutorialConnection : this.connection;
		return c.CallRoute('keep-hand', payload);
	}

	GetBalance(){
		return this.connection.CallRoute("get-balance");
	}

	ensurePlayerCanRoll = (id, round) => {
		console.log('Waiting for opponent...');
		return new Promise((resolve, reject) => {
			(function poll(){
				setTimeout(() => {
					this.GetMatch(id)
					.then((matchData) => {
						var opponentRounds = matchData.Payload.Match.Opponents[0].MatchRounds.length;
						var playerRounds = matchData.Payload.Match.UserMatchRounds.length;
						if(opponentRounds < playerRounds){
							console.log('still waiting...');
							poll.call(this);
						} else {
							console.log('opponent is ready!');
							resolve(matchData);
						}
					})
				}, 1000);
			}).bind(this)();
		});
	}

	UseFreeRoll(matchId){
		var c = store.tutorialMode ? this.tutorialConnection : this.connection;
		return c.CallRoute("apply-free-roll", {
			MatchId: matchId
		})
	}

	UseHandReset(matchId){
		return this.connection.CallRoute("apply-hand-reset", {
			MatchId: matchId
		})
	}

	AdvanceRound(id) {
		console.log('Advance Round');
		return new Promise((resolve, reject) => {
			(function roller(held){
				this.ContinueRoll(id, (held || []))
				.then((rollResult) => {
					console.log('rolled');
					const roll = rollResult.Payload.Match.UserMatchRounds.pop();
					if (roll.State === 'co') {
						console.log('server completed hand');
						//hand is already ended
						resolve();
					} else if (rollResult.Payload.Match.CanKeepHand) {
						console.log('Hand Can be kept. complete hand.');
						//hand is complete must submit hand
						this.CompleteHand(id, roll.BestHand)
						.then(() => {
							resolve();
						})
					} else if(rollResult.Payload.Match.CanRollDice) {
						//ready for next roll.
						console.log('roll again...');
						roller.call(this, roll.BestHand);
					}
				})
			}).bind(this)();
		})

	} // end advance round

	PlayToState(matchId, rounds, hands) {

		var rollUntilReady = (id, roundNum, handNum) => {
			console.log('roll to reach round/hand',roundNum,handNum);
			var currentRound = 1;
			var currentHand = 1;

			return new Promise((resolve, reject) => {


				function handEnd(func){
					currentHand++;
					if (currentHand > 3) {
						currentRound++;
						currentHand = 1;
						if (currentRound >= roundNum && currentHand >= handNum) {
							console.log('target round reached, resolving.');
							resolve();
						} else {
							console.log('advance another round...');
							this.ensurePlayerCanRoll(id)
							.then(() => {
								func([]);
							})
						}
					} else {
						func([]);
					}
				}

				(function roller(held){
					if (currentRound >= roundNum && currentHand >= handNum) {
						resolve();
						return;
					}
					this.ContinueRoll(id, (held || []))
					.then((rollResult) => {
						console.log('rolled');
						if (rollResult.Payload.MatchRoll.Completed) {
							console.log('server completed hand');
							//hand is already ended
							handEnd.call(this,roller.bind(this));
						} else if (rollResult.Payload.MatchRoll.RollNum >= 3) {
							console.log('3rd roll spent.  complete hand.');
							//hand is complete must submit hand
							this.CompleteHand(id, rollResult.Payload.MatchRoll.BestHand)
							.then(() => {
								handEnd.call(this, roller.bind(this));
							})
						} else {
							//ready for next roll.
							if (currentRound >= roundNum && currentHand >= handNum) {
								resolve();
							} else {
								console.log('roll again...');
								roller.call(this, rollResult.Payload.MatchRoll.BestHand);
							}
						}
					})
				}).bind(this)();
			})
		};


		this.GetMatch(matchId)
			.then((matchResponse) => {
				return new Promise((resolve, reject) => {
					if (!rounds && !hands) {
						console.log('Cheat enabled but no cheatRound or cheatHand defined')
						resolve();
					} else {
						rounds += matchResponse.Payload.Match.Rounds.length - 1;

						rollUntilReady(matchResponse.Payload.Match.MatchId, rounds, hands)
						.then(() => {
							console.log('Hand Advancement Complete');
							resolve()
						});
					}
				});
			})
			.then(() => {
				store.betProcessing = false;
			});
	} // end playto state
}

//Remove allowed, join, leave, set-invite
//Tournament Type: QT, FT
